import { Injectable } from '@angular/core'
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Observable } from 'rxjs'

import { map } from 'rxjs/operators'
import { AccountAuthorization, PaginatedList } from '../../../shared/shared.interfaces'
import { environment } from '../../../../environments/environment'
import { CreateAuthorizationRequest } from '../../../shared/interfaces/create-authorization-request'

@Injectable({
  providedIn: 'root',
})
export class RestrictedProductAuthorizationService {
  constructor(private httpClient: HttpClient) {}
  getAccountAuthorizations(accountId: number, pageIndex: number, pageSize: number): Observable<any> {
    const params: { [key: string]: number } = { pageSize, pageIndex }
    const searchParams = new URLSearchParams()
    for (const key in params) {
      if (params[key] != null) {
        searchParams.append(key, params[key].toString())
      }
    }
    const url = `${environment.restrictedProductUrl}/${accountId}/RestrictedProductAccountAuthorizations?${searchParams}`
    return this.httpClient.get<PaginatedList<AccountAuthorization>>(url).pipe(map((list) => list))
  }
  saveAccountAuthorizations(
    accountId: number,
    authorizationRequest: Partial<CreateAuthorizationRequest>
  ): Observable<AccountAuthorization> {
    const headers = new HttpHeaders({
      Accept: 'application/json',
    })
    const requestOptions = {
      headers,
    }
    return this.httpClient.post<AccountAuthorization>(
      `${environment.restrictedProductUrl}/${accountId}/RestrictedProductAccountAuthorizations`,
      authorizationRequest,
      requestOptions
    )
  }

  updateAccountAuthorizations(
    accountId: number,
    authorizationId: number,
    authorizationData
  ): Observable<AccountAuthorization> {
    const headers = new HttpHeaders({
      Accept: 'application/json',
    })
    const requestOptions = {
      headers,
    }
    return this.httpClient.put<AccountAuthorization>(
      `${environment.restrictedProductUrl}/${accountId}/RestrictedProductAccountAuthorizations/${authorizationId}`,
      authorizationData,
      requestOptions
    )
  }

  getPdf(accountId: number, authorizationId: number) {
    const headers = new HttpHeaders({
      Accept: 'application/allegion.dke.restrictedproductauthorization+pdf',
    })
    const requestOptions = {
      headers,
      responseType: 'blob' as 'json',
    }
    const url = `${environment.restrictedProductUrl}/${accountId}/RestrictedProductAccountAuthorizations/${authorizationId}`

    return this.httpClient.get(url, requestOptions).pipe(map((response) => response as Blob))
  }

  generateDummyAuthorization(accountId: number): Observable<Blob> {
    const headers = new HttpHeaders({
      Accept: 'application/allegion.dke.restrictedproductauthorization+pdf',
    })
    const requestOptions = {
      headers,
      responseType: 'blob' as 'json',
    }
    const url = `${environment.restrictedProductUrl}/${accountId}/RestrictedProductAccountAuthorizations`

    return this.httpClient.post(url, {}, requestOptions).pipe(map((response) => response as Blob))
  }
}
